import React, { memo, useCallback } from 'react';
import { Grid, Segment } from 'semantic-ui-react';
import { ChevronDownIcon, ChevronUpIcon, InvestmentIcon } from '../../Icon';
import { formatMoney } from '../../../utils/formatters';
import { InvestmentDetails } from './InvestmentDetails';
import { mapInvestmentTypeToText } from './utils';


var Investment = function (_a) {
    var investments = _a.investments, isSelected = _a.isSelected, onClick = _a.onClick, investmentTransactionsLoading = _a.investmentTransactionsLoading;
    var handleInvestmentClick = useCallback(function () {
        onClick === null || onClick === void 0 ? void 0 : onClick(investments[0].id);
    }, [investments, onClick]);
    var balance = investments.reduce(function (acc, investment) { return acc + investment.balance; }, 0);
    return (React.createElement(Segment, { className: 'Investment pluggy' },
        React.createElement(Grid, { columns: 3 },
            React.createElement(Grid.Row, { className: 'investment-row' },
                React.createElement(Grid.Column, { className: 'product-brand' },
                    React.createElement("div", { className: 'product-logo' },
                        React.createElement(InvestmentIcon, null)),
                    React.createElement("div", { className: 'product-name' },
                        React.createElement("p", { className: 'column-header' }, "Nome"),
                        React.createElement("p", null, mapInvestmentTypeToText(investments[0].type)))),
                React.createElement(Grid.Column, { className: 'balance-column' },
                    React.createElement("p", { className: 'column-header' }, "Balance"),
                    React.createElement("p", null, formatMoney(balance, investments[0].currencyCode))),
                React.createElement(Grid.Column, { textAlign: 'right', verticalAlign: 'middle', className: 'icon-column', onClick: handleInvestmentClick }, investmentTransactionsLoading ? (React.createElement("div", { className: 'skeleton arrow-action' })) : isSelected ? (React.createElement(ChevronUpIcon, { onClick: handleInvestmentClick })) : (React.createElement(ChevronDownIcon, { onClick: handleInvestmentClick }))))),
        isSelected && React.createElement(InvestmentDetails, { investments: investments })));
};
export default memo(Investment);
